/* Tag Categories
1. Promo: Signature, Free Delivery, Best Seller, New
2. Nutrition Info: High Protein, High Fiber, Low Cal, Low Carb, Good for skin
3. Restriction: Vegan, No diary, No gluten
4. Personal: Frequency Purchase, Last Purchase, (Doesn’t contain what you don’t like)
*/
import colors from 'styles/colors'
import { ProductTags, Tag, TagCategory } from 'types/ProductTag'

export const TAGS: ProductTags = {
  SustainablyFarmed: {
    nameEn: 'Sustainably farmed',
    nameTh: 'Sustainably farmed',
    categories: [TagCategory.Complementary],
  },
  YourFavorite: {
    nameEn: 'YourFavorite',
    nameTh: 'YourFavorite',
    categories: [TagCategory.Other],
  },
  JMenu: {
    nameEn: 'J Menu',
    nameTh: 'J Menu',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
    bgColor: colors.yellow100,
    color: colors.yellow,
    icon: 'j-menu',
  },
  HighFiber: {
    nameEn: 'High Fiber',
    nameTh: 'High Fiber',
    categories: [TagCategory.Complementary],
  },
  HighIron: {
    nameEn: 'High Iron',
    nameTh: 'High Iron',
    categories: [TagCategory.Complementary],
  },
  NoPlastic: {
    nameEn: 'No plastic',
    nameTh: 'No plastic',
    categories: [TagCategory.Complementary],
  },
  HighVitaminC: {
    nameEn: 'High Vitamin C',
    nameTh: 'High Vitamin C',
    categories: [TagCategory.Complementary],
  },
  LowCal: {
    nameEn: 'Low-Calories',
    nameTh: 'Low-Calories',
    categories: [TagCategory.Complementary],
  },
  PlantBased: {
    nameEn: 'Plant-based',
    nameTh: 'Plant-based',
    categories: [TagCategory.Complementary],
  },
  ContainsProbiotic: {
    nameEn: 'Contains probiotic',
    nameTh: 'Contains probiotic',
    categories: [TagCategory.Complementary],
  },
  FrequentlyPurchased: {
    nameEn: 'Frequently purchased',
    nameTh: 'Frequently purchased',
    categories: [TagCategory.Other],
  },
  BoostingImmuneSystem: {
    nameEn: 'Boosting immune system',
    nameTh: 'ช่วยในการเสริมสร้างภูมิคุ้มกัน',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.purple100,
    color: colors.purple500,
    icon: 'immune-system',
  },
  HighVitaminB: {
    nameEn: 'High Vitamin B',
    nameTh: 'High Vitamin B',
    categories: [TagCategory.Complementary],
  },
  OceanLifeSafe: {
    nameEn: 'Ocean life safe',
    nameTh: 'Ocean life safe',
    categories: [TagCategory.Complementary],
  },
  HighVitaminD: {
    nameEn: 'High Vitamin D',
    nameTh: 'High Vitamin D',
    categories: [TagCategory.Complementary],
  },
  SugarFree: {
    nameEn: 'Sugar-free',
    nameTh: 'Sugar-free',
    categories: [TagCategory.Complementary],
  },
  RecycleablePackaging: {
    nameEn: 'Recyclable packaging',
    nameTh: 'Recyclable packaging',
    categories: [TagCategory.Complementary],
  },
  BestSeller: {
    nameEn: 'Best seller',
    nameTh: 'Best seller',
    categories: [TagCategory.Other],
  },
  PesticideFree: {
    nameEn: 'Pesticide-free',
    nameTh: 'ปลอดสาร',
    categories: [TagCategory.Complementary],
  },
  Compostable: {
    nameEn: 'Compostable',
    nameTh: 'Compostable',
    categories: [TagCategory.Complementary],
  },
  GoodForBrain: {
    nameEn: 'Good for brain',
    nameTh: 'Good for brain',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.yellow100,
    color: colors.yellow,
    icon: 'good-for-brain',
  },
  NoMSG: {
    nameEn: 'No MSG',
    nameTh: 'No MSG',
    categories: [TagCategory.Complementary],
  },
  CholesterolFree: {
    nameEn: 'Cholesterol-free',
    nameTh: 'Cholesterol-free',
    categories: [TagCategory.Restriction],
  },
  NonGMO: {
    nameEn: 'Non-GMO',
    nameTh: 'Non-GMO',
    categories: [TagCategory.Complementary],
  },
  ContainsFish: {
    nameEn: 'Contains Fish',
    nameTh: 'Contains Fish',
    categories: [TagCategory.Restriction],
  },
  GainingMuscle: {
    nameEn: 'Gaining Muscle',
    nameTh: 'เสริมสร้างกล้ามเนื้อ',
    categories: [TagCategory.Diet, TagCategory.Fitness, TagCategory.Benefit],
    bgColor: colors.orange100,
    color: colors.orange,
    icon: 'gain-muscle',
  },
  SupportsLocalCommunity: {
    nameEn: 'Supports local community',
    nameTh: 'Supports local community',
    categories: [TagCategory.Environmental, TagCategory.Benefit],
    bgColor: colors.brown100,
    color: colors.brown500,
    icon: 'supports-local-community',
  },
  FreeRange: {
    nameEn: 'Free-range',
    nameTh: 'Free-range',
    categories: [TagCategory.Environmental, TagCategory.Benefit],
    bgColor: colors.orange100,
    color: colors.orange,
    icon: 'free-range',
  },
  NoAddedSugar: {
    nameEn: 'No added sugar',
    nameTh: 'No added sugar',
    categories: [TagCategory.Complementary],
  },
  DirectFromFarmers: {
    nameEn: 'Direct from farmers',
    nameTh: 'Direct from farmers',
    categories: [TagCategory.Complementary],
  },
  ContainsEgg: {
    nameEn: 'Contains Egg',
    nameTh: 'Contains Egg',
    categories: [TagCategory.Restriction],
  },
  OrganicIngredients: {
    nameEn: 'Organic ingredients',
    nameTh: 'Organic ingredients',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.green100,
    color: colors.green500,
    icon: 'organic-ingredients',
  },
  LowCarb: {
    nameEn: 'Low-Carb',
    nameTh: 'Low-Carb',
    categories: [TagCategory.Complementary],
  },
  LowGI: {
    nameEn: 'Low-GI',
    nameTh: 'Low-GI',
    categories: [TagCategory.Complementary],
  },
  LowSugar: {
    nameEn: 'Low-Sugar',
    nameTh: 'Low-Sugar',
    categories: [TagCategory.Complementary],
  },
  HighOmegaFat: {
    nameEn: 'High Omega Fat',
    nameTh: 'High Omega Fat',
    categories: [TagCategory.Complementary],
  },
  Light: {
    nameEn: 'Light',
    nameTh: 'Light',
    categories: [TagCategory.Other],
  },
  Biodegradable: {
    nameEn: 'Biodegradable',
    nameTh: 'Biodegradable',
    categories: [TagCategory.Complementary],
  },
  GlutenFree: {
    nameEn: 'Gluten-free',
    nameTh: 'Gluten-free',
    categories: [TagCategory.Restriction],
  },
  New: {
    nameEn: 'New',
    nameTh: 'New',
    categories: [TagCategory.Other],
  },
  Vegetarian: {
    nameEn: 'Vegetarian',
    nameTh: 'Vegetarian',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
    bgColor: colors.green100,
    color: colors.green500,
    icon: 'vegetarian',
  },
  HighCalcium: {
    nameEn: 'High Calcium',
    nameTh: 'High Calcium',
    categories: [TagCategory.Complementary],
  },
  PeanutFree: {
    nameEn: 'Peanut-free',
    nameTh: 'Peanut-free',
    categories: [TagCategory.Restriction],
  },
  LowFat: {
    nameEn: 'Low-Fat',
    nameTh: 'Low-Fat',
    categories: [TagCategory.Complementary],
  },
  LowUricAcid: {
    nameEn: 'Low Uric acid',
    nameTh: 'Low Uric acid',
    categories: [TagCategory.Complementary],
  },
  ContainsShrimp: {
    nameEn: 'Contains Shrimp',
    nameTh: 'Contains Shrimp',
    categories: [TagCategory.Restriction],
  },
  NoPreservatives: {
    nameEn: 'No Preservatives',
    nameTh: 'No Preservatives',
    categories: [TagCategory.Complementary],
  },
  SoyFree: {
    nameEn: 'Soy-free',
    nameTh: 'Soy-free',
    categories: [TagCategory.Restriction],
  },
  WeightControl: {
    nameEn: 'Weight Control',
    nameTh: 'ช่วยควบคุมน้ำหนัก',
    categories: [TagCategory.Diet, TagCategory.Fitness, TagCategory.Benefit],
    bgColor: colors.purple100,
    color: colors.purple500,
    icon: 'controlling-weight',
  },
  GoodForBlood: {
    nameEn: 'Good for blood',
    nameTh: 'บำรุงเลือด',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.red100,
    color: colors.red,
    icon: 'good-for-blood',
  },
  LowSodium: {
    nameEn: 'Low-Sodium',
    nameTh: 'Low-Sodium',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
    bgColor: colors.blue100,
    color: colors.blue500,
    icon: 'low-sodium',
  },
  Paleo: {
    nameEn: 'Paleo',
    nameTh: 'Paleo',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
    bgColor: colors.blue100,
    color: colors.blue500,
    icon: 'low-sodium',
  },
  HighVitaminA: {
    nameEn: 'High Vitamin A',
    nameTh: 'High Vitamin A',
    categories: [TagCategory.Complementary],
  },
  LandSafe: {
    nameEn: 'Land safe',
    nameTh: 'Land safe',
    categories: [TagCategory.Complementary],
  },
  DairyFree: {
    nameEn: 'Dairy-free',
    nameTh: 'Dairy-free',
    categories: [TagCategory.Restriction],
  },
  RecentlyPurchased: {
    nameEn: 'Recently purchased',
    nameTh: 'Recently purchased',
    categories: [TagCategory.Other],
  },
  Signature: {
    nameEn: 'Signature',
    nameTh: 'Signature',
    categories: [TagCategory.Other],
  },
  Homemade: {
    nameEn: 'Homemade',
    nameTh: 'Homemade',
    categories: [TagCategory.Environmental, TagCategory.Benefit],
    bgColor: colors.yellow100,
    color: colors.yellow,
    icon: 'homemade',
  },
  HighProtein: {
    nameEn: 'High Protein',
    nameTh: 'High Protein',
    categories: [TagCategory.Complementary],
  },
  Vegan: {
    nameEn: 'Vegan',
    nameTh: 'Vegan',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
    bgColor: colors.green100,
    color: colors.green500,
    icon: 'vegan',
  },
  GoodForSkin: {
    nameEn: 'Good for skin',
    nameTh: 'บำรุงผิว',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.purple100,
    color: colors.purple500,
    icon: 'good-for-skin',
  },
  GoodForEyes: {
    nameEn: 'Good for eyes',
    nameTh: 'บำรุงสายตา',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.orange100,
    color: colors.orange,
    icon: 'good-for-eyes',
  },
  GoodForBone: {
    nameEn: 'Good for bone',
    nameTh: 'บำรุงกระดูก',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.blue100,
    color: colors.blue500,
    icon: 'good-for-bone',
  },
  ImprovingDigestion: {
    nameEn: 'Improving digestion',
    nameTh: 'ช่วยในระบบขับถ่าย',
    categories: [TagCategory.Wellness, TagCategory.Benefit],
    bgColor: colors.brown100,
    color: colors.brown500,
    icon: 'digestive-system',
  },
  Sustainable: {
    nameEn: 'Save the planet',
    nameTh: 'Save the planet',
    categories: [TagCategory.Environmental, TagCategory.Benefit],
    bgColor: colors.green100,
    color: colors.green500,
    icon: 'save-the-planet',
  },
  HighAntioxidant: {
    nameEn: 'High Antioxidant',
    nameTh: 'High Antioxidant',
    categories: [TagCategory.Complementary],
  },
  LocallySourced: {
    nameEn: 'Locally sourced',
    nameTh: 'Locally sourced',
    categories: [TagCategory.Complementary],
  },
  CanbeJ: {
    nameEn: 'Can be J',
    nameTh: 'Can be J',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
  },
  Keto: {
    nameEn: 'Keto',
    nameTh: 'Keto',
    categories: [TagCategory.SpecialNeeds, TagCategory.Benefit],
  },
  CanbeGlutenFree: {
    nameEn: 'Can be gluten free',
    nameTh: 'Can be gluten free',
    categories: [TagCategory.Restriction],
  },
  Exclusive: {
    nameEn: 'Exclusive',
    nameTh: 'Exclusive',
    categories: [TagCategory.Other],
  },
}

const tagCatgories = [
  {
    categoryName: 'default',
    listData: [],
  },
  {
    categoryName: 'promo',
    listData: [
      { Signature: 'Signature' },
      { FreeDelivery: 'Free Delivery' },
      { BestSeller: 'Best Seller' },
      { New: 'New' },
    ],
  },
  {
    categoryName: 'nutrition',
    listData: [
      { HighProtein: 'High Protein' },
      { HighFiber: 'High Fiber' },
      { LowCal: 'Low Cal' },
      { LowCarb: 'Low Carb' },
      { Goodforskin: 'Good for skin' },
      { Light: 'Light' },
    ],
  },
  {
    categoryName: TagCategory.Restriction,
    listData: [{ Vegan: 'Vegan' }, { Nodiary: 'No diary' }, { Nogluten: 'No gluten' }],
  },
  {
    categoryName: 'personal',
    listData: [{ FrequencyPurchase: 'Frequency Purchase' }, { LastPurchase: 'Last Purchase' }],
  },
]

export const getDataTags = (tags: string[]) => {
  const _tags: Tag[] = []
  tags.forEach((tag) => {
    if (TAGS[tag]) {
      _tags.push(TAGS[tag])
    }
  })
  return _tags
}

export const getTagCategoryAndWordingByTagName = (tagName) => {
  let tagNameMapping = ''

  // Find tagName category
  const tagCategory = tagCatgories.find((category) => {
    return category.listData.some((data) => {
      if (Object.keys(data)[0] === tagName) {
        tagNameMapping = data[tagName]
        return true
      } else {
        return false
      }
    })
  })

  // If have result
  if (tagCategory) {
    return {
      categoryName: tagCategory.categoryName,
      tagNameMapping,
    }
  }
  // If no have return default
  else {
    return {
      categoryName: tagCatgories[0].categoryName,
      tagNameMapping: tagName,
    }
  }
}

export const SPICYLEVEL = {
  NOT_SPICY: 'NotSpicy',
  MILD: 'Mild',
  MEDIUM: 'Medium',
  HOT: 'Hot',
}
